"use client";
import React from "react";
import Button from "@/components/primitives/button";
import { useScrollPosition } from "@/utils/hooks/use-scroll-position";

interface StickyBottomBarProps {
  logoUrl?: string;
  sportsbookTitle: string;
  sportsbookUrl: string;
  sportsbookColor?: string;
}

export default function StickyBottomBar({
  logoUrl,
  sportsbookTitle,
  sportsbookUrl,
  sportsbookColor = "#151c26",
}: StickyBottomBarProps) {
  const isVisible = useScrollPosition({ threshold: 300 });

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out transform bg-surface-700 ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
      style={{
        // backgroundColor: sportsbookColor,
        // borderTop: '2px solid rgba(255, 255, 255, 0.1)',
        // backdropFilter: 'blur(10px)'
        boxShadow: "0px -4px 8px 0px #0000001F",
        pointerEvents: isVisible ? "auto" : "none",
      }}
    >
      <div className="mx-auto px-4 py-4 lg:py-4 container">
        <div className="flex justify-between items-center gap-4">
          {/* Left side - Logo */}
          <div className="flex flex-1 items-center min-w-0">
            {logoUrl && (
              <div className="flex items-center">
                <img
                  src={logoUrl}
                  alt={sportsbookTitle}
                  className="w-auto max-w-[120px] lg:max-w-[120px] h-7 lg:h-8 object-contain"
                />
              </div>
            )}
            {!logoUrl && (
              <div className="font-bold text-white text-base lg:text-lg truncate">
                {sportsbookTitle}
              </div>
            )}
          </div>

          {/* Right side - CTA Button */}
          <div className="shrink-0">
            <Button
              href={sportsbookUrl}
              target="_blank"
              size="md"
              // className="shadow-lg hover:shadow-xl !px-4 lg:!px-6 !py-2 lg:!py-3 !font-bold !text-xs lg:!text-sm whitespace-nowrap transition-shadow"
            >
              Join {sportsbookTitle}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
